export enum RegisterFromEnum {
  CASIO_EDU = "casioedu",
}
